import { render, staticRenderFns } from "./recipe-layout.vue?vue&type=template&id=5ab31738"
import script from "./recipe-layout.vue?vue&type=script&lang=js"
export * from "./recipe-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports